import styled from 'vue-styled-components';

export const Wrapper = styled.div``;

export const LineCustom = styled.span`
  display: block;
  width: 100%;
  border: 1px solid #dee1db;
  margin: 2rem 0 2.5rem 0;
  h1{
    color: white;
  }
`;
